import { useEntityAI } from "@/api/useInventory"
import { getWorkflowAi } from "@/pages/DiscoveryPage/application/ai-discovery/useAiDiscovery.select"

import type { WorkflowAiResponse } from "@/api/useInventory.types"
import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const useAgentById = (props: Pick<TabComponentProps, "record">) => {
  const { record } = props

  const ctx = useEntityAI(record?.id, "agent")
  const { response, isLoading } = ctx
  const { data } = response || {}

  return { data, isLoading }
}

export const useWorkflowById = (props: Pick<TabComponentProps, "record">) => {
  const { record } = props
  const ctx = useEntityAI<WorkflowAiResponse, ReturnType<typeof getWorkflowAi>>(
    record?.id,
    "workflow",
    undefined,
    { select: getWorkflowAi }
  )
  const { response, isLoading } = ctx
  const { data } = response || {}

  return { data, isLoading }
}
